import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const VisitorNavbar: React.FC = () => {
    return (
        <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div className="container flex h-16 items-center justify-between">
                <div className="flex items-center gap-4">
                    <Link to="/" className="flex items-center gap-3">
                        <img src="/logo.png" alt="ADJJA Academy" className="w-8 h-8 rounded-full object-cover" />
                        <span className="font-bold text-xl tracking-tight">ADJJA Academy</span>
                    </Link>
                    <div className="hidden md:flex h-6 w-px bg-slate-200 dark:bg-slate-800" />
                    <span className="hidden md:inline-block text-sm font-medium text-muted-foreground">
                        Grappler Profile
                    </span>
                </div>

                <div className="flex items-center gap-4">
                    <Link to="/login">
                        <Button variant="ghost" size="sm" className="font-medium text-muted-foreground hover:text-foreground">
                            Log In
                        </Button>
                    </Link>
                    <Link to="/register">
                        <Button size="sm" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-6 shadow-sm">
                            Sign Up
                        </Button>
                    </Link>
                </div>
            </div>
        </header>
    );
};
